(function (win, $) {
    'use strict';
    var fp = (win.fp = typeof win.fp !== 'undefined' ? win.fp : {}),
        home = (fp.home = typeof fp.home !== 'undefined' ? fp.home : {});

    var getScreenSize = function () {
        var pixelDensity = window.devicePixelRatio || 1;
        var width = window.innerWidth * pixelDensity;

        if (width >= 2400) {
            return 'xlarge';
        }
        if (width >= 1400) {
            return 'large';
        }
        if (width >= 1000) {
            return 'medium';
        }
        if (width >= 600) {
            return 'small';
        }
        return 'xsmall';
    };

    fp.home = (function () {
        var windowHeight;
        var initialized = false;

        // =========================================
        // Set Hero Size
        // =========================================
        var setHeroSize = function (initialLoad) {
            var height = $(window).height();
            var headerHeight = $('header').outerHeight(); // Fixed: added parentheses
            var specialMessageHeight = 0; // Default to 0 in case special message (banner) doesn't exist
            var fixedFooterHeight = 0; // Default to 0 in case fixed footer doesn't exist
            var logoMobileHeight = 0; // Default to 0 in case logo-mobile doesn't exist

            var specialMessage = $('#special-message.message-banner');
            if (specialMessage.length && specialMessage.is(':visible')) {
                specialMessageHeight = specialMessage.outerHeight();
            }

            var fixedFooter = $('#fixed-footer');
            if (fixedFooter.length && fixedFooter.is(':visible')) {
                fixedFooterHeight = fixedFooter.outerHeight();
            }

            var logoMobile = $('#logo-mobile');
            if (logoMobile.length && logoMobile.is(':visible')) {
                logoMobileHeight = logoMobile.outerHeight();
            }

            var maxHeight = height - specialMessageHeight - headerHeight - logoMobileHeight - fixedFooterHeight;
            $('.slideshow').css('height', maxHeight);
            //console.log("SLIDESHOW HEIGHT: " + maxHeight);

            if (initialLoad) {
                $('body').removeClass('fade-home-contents');
                setTimeout(function () {
                    $('body').addClass('hero-set');
                }, 1000);
            }
        };

        // =========================================
        // Set Background Image
        // =========================================
        var setBgImage = function (imgInfo) {
            if (!Array.isArray(imgInfo) || !imgInfo.length) {
                //console.warn("[setBgImage] Invalid or empty imgInfo array.");
                return;
            }

            var slideshowEl = document.querySelector('.slideshow.slideshow-photo');

            if (!slideshowEl) {
                //console.warn("[setBgImage] .slideshow.slideshow-photo not found in DOM.");
                return;
            }

            var screenSize = getScreenSize();
            var filteredImages = imgInfo.filter(function (img) {
                return img.assetSize === screenSize;
            });

            if (!filteredImages.length) {
                //console.warn(`[setBgImage] No matching images found for screen size: ${screenSize}`);
                return;
            }

            var randomImage = filteredImages[Math.floor(Math.random() * filteredImages.length)];

            slideshowEl.style.backgroundImage = `url('${randomImage.imagePath}')`;

            if (randomImage.altText) {
                slideshowEl.setAttribute('aria-label', randomImage.altText);
                slideshowEl.setAttribute('role', 'img');
            }

            //console.log(`[setBgImage] Applied background: ${randomImage.imagePath}`);
        };

        // =========================================
        // Set Video Controls
        // =========================================
        var setupVideoControls = function () {
            var video = document.getElementById('bg-video');
            var videoButton = document.getElementById('video-pause-play');
            var videoButtonIcon = videoButton ? videoButton.querySelector('span') : null; // Fixed here
            var controlAnnouncements = document.getElementById('video-control-announcements');

            if (!video || !videoButton || !controlAnnouncements) {
                return;
            }

            videoButton.addEventListener('click', function () {
                if (!video.paused) {
                    video.pause();
                    videoButton.setAttribute('aria-label', 'Play video');
                    videoButtonIcon.classList.replace('icon-pause', 'icon-play');
                    controlAnnouncements.textContent = 'Video paused';
                } else {
                    video.play();
                    videoButton.setAttribute('aria-label', 'Pause video');
                    videoButtonIcon.classList.replace('icon-play', 'icon-pause');
                    controlAnnouncements.textContent = 'Video playing';
                }
            });
        };

        // Public API
        return {
            init: function () {
                $('.homepage-link').addClass('selected');

                // Initialize hero size
                setHeroSize(true);

                // Initialize video controls
                setupVideoControls();

                $(window).resize(function () {
                    setHeroSize(false);
                });
            },
            setBgImage: setBgImage
        };
    })();
})(window, $);